<template>
    <Transition name="fade">
        <div
            v-if="isOffline"
            class="fixed inset-0 z-9999 flex flex-col items-center justify-center bg-white px-8 text-center"
        >
            <svg
                class="mb-6 h-16 w-16 text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M18.364 5.636a9 9 0 010 12.728M15.536 8.464a5 5 0 010 7.072M12 12h.01M3 3l18 18"
                />
            </svg>
            <h2 class="font-noto mb-2 text-xl text-gray-800">
                {{ t("offline_screen.title") }}
            </h2>
            <p class="text-sm text-gray-500">
                {{ t("offline_screen.message") }}
            </p>
        </div>
    </Transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n({ useScope: "global" });

const isOffline = ref(false);

const handleNetworkChange = (event) => {
    isOffline.value = !event.detail.connected;
};

onMounted(() => {
    document.addEventListener("networkStatusChange", handleNetworkChange);
});

onUnmounted(() => {
    document.removeEventListener("networkStatusChange", handleNetworkChange);
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
